var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDarkWebRock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8665 6V5.13333C4.8665 3.4 6.2665 2 7.99984 2C8.79984 2 9.53317 2.33333 10.0665 2.8M7.99984 10.0667V11.4M11.3332 14.0667H4.6665C3.53317 14.0667 2.6665 13.2 2.6665 12.0667V8.06667C2.6665 6.93333 3.53317 6.06665 4.6665 6.06665H11.3332C12.4665 6.06665 13.3332 6.93333 13.3332 8.06667V12.0667C13.3332 13.1333 12.4665 14.0667 11.3332 14.0667ZM7.33317 9.33333C7.33317 9.11113 7.4665 8.66667 7.99984 8.66667C8.53317 8.66667 8.6665 9.11113 8.6665 9.33333C8.6665 9.55553 8.53317 10 7.99984 10C7.4665 10 7.33317 9.55553 7.33317 9.33333Z",
    stroke: "#FD4C45",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDarkWebRock);
export default __webpack_public_path__ + "static/media/icon-dark-web-rock.a4869a652c2f0a3e1aa510a4ef3ee78c.svg";
export { ForwardRef as ReactComponent };